<template>
  <div class="detail">
    <div class="left">
      <div class="bold">
        {{ credenciado.nome }}
      </div>
      <Func4Acreditacao :acreditacoes="credenciado.acreditacoes" />
      <div class="small">
        {{ credenciado.esp }}
      </div>
    </div>
    <div class="right">
      <div class="bold">
        {{ credenciado.tel }}
      </div>
      <div v-if="credenciado.tel_sec" class="bold">
        {{ credenciado.tel_sec }}
      </div>
      <div class="small">
        <span>
          {{ credenciado.endereco }}
        </span>
        <span>
          {{ credenciado.numero }}
        </span>
        <span>
          {{ credenciado.complemento }}
        </span>
        <span>
          {{ credenciado.bairro }}
        </span>
        <span>
          {{ credenciado.cid }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Func4Acreditacao from '@/views/4/Acreditacao'

export default {
  name: 'Func4PrintDetail',
  components: { Func4Acreditacao },
  props: {
    credenciado: {}
  }
}
</script>

<style scoped lang="less">

.detail {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-right: 1px solid lightgray;
  border-bottom: 1px solid lightgray;

  &:nth-child(even) {
    border-right: none;
  }

  .left {
    min-width: 65%;
  }

  .bold {
    font-weight: bold;
  }

  .small {
    font-size: smaller;
  }
}

</style>
